import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export interface AttachmentDialogData {
  url: string;
  fileName: string;
  fileType: string;
}

@Component({
  selector: 'app-admin-attachment-dialog',
  templateUrl: './attachment-dialog.component.html',
  styleUrls: ['./attachment-dialog.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminAttachmentDialogComponent {
  safeUrl: SafeResourceUrl;

  constructor(
    public dialogRef: MatDialogRef<AdminAttachmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AttachmentDialogData,
    sanitizer: DomSanitizer,
  ) {
    this.safeUrl = sanitizer.bypassSecurityTrustResourceUrl(data.url);
  }

  get kind(): 'image' | 'video' | 'audio' | 'pdf' | 'other' {
    const t = (this.data.fileType || '').toLowerCase();
    const ext = (this.data.fileName.split('.').pop() || '').toLowerCase();
    if (t.startsWith('image/') || ['png', 'jpg', 'jpeg', 'gif'].includes(ext)) return 'image';
    if (t.startsWith('video/') || ['mp4', 'mov', 'avi', 'wmv'].includes(ext)) return 'video';
    if (t.startsWith('audio/') || ['mp3', 'wav'].includes(ext)) return 'audio';
    if (t === 'application/pdf' || ext === 'pdf') return 'pdf';
    return 'other';
  }

  close(): void {
    this.dialogRef.close();
  }

  download(): void {
    window.open(this.data.url, '_blank', 'noopener,noreferrer');
  }
}
